import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';
import { EMAIL_EVENT_TYPES } from '@pendo/middleware';

const { DELIVERED, OPEN, CLICK } = EMAIL_EVENT_TYPES;

export const noEmailActivityTypeMap = {
    notdelivered: DELIVERED,
    notopened: OPEN,
    notclicked: CLICK,
};

export function buildEmailActivityFilterString (type, filterIndex) {
    return `engagements${filterIndex}.${type}.count>0`;
}

export function buildNoEmailActivityFilterString (type, filterIndex) {
    return `(isNil(engagements${filterIndex}.${type})||engagements${filterIndex}.${type}.count==0)`;
}

export function buildEmailTimeBeforeFilterString ({ first, type, filterIndex }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `engagements${filterIndex}.${type}.first<=date("${date}")`;
}

export function buildNotEmailTimeBeforeFilterString ({ first, type, filterIndex }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `engagements${filterIndex}.${type}.first>=date("${date}")`;
}

export function buildEmailTimeSinceFilterString ({ type, first, filterIndex }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `engagements${filterIndex}.${type}.last>=date("${date}")`;
}

export function buildNotEmailTimeSinceFilterString ({ type, first, filterIndex }) {
    const date = moment(first, { ignoreTimeZone: true }).format(DATE_FORMAT.iso);

    return `engagements${filterIndex}.${type}.last<=date("${date}")`;
}

export function buildEmailTimeWithinLastFilterString ({ type, count, granularity, filterIndex }) {
    return `(engagements${filterIndex}.${type}.last>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function buildNotEmailTimeWithinLastFilterString ({ type, count, granularity, filterIndex }) {
    return `(engagements${filterIndex}.${type}.last<=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function buildEmailTimeNotWithinLastFilterString ({ type, count, granularity, filterIndex }) {
    return `(engagements${filterIndex}.${type}.last<=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function buildNotEmailTimeNotWithinLastFilterString ({ type, count, granularity, filterIndex }) {
    return `(engagements${filterIndex}.${type}.last<=now()||engagements${filterIndex}.${type}.last>=dateAdd(startOfPeriod("daily",now()),-${count},"${granularity}"))`;
}

export function parseEmailFilterPipeline ({ fact, time, ...params }) {
    let filterString = '';
    let type = '';

    switch (fact) {
        case 'delivered':
        case 'opened':
        case 'clicked':
            filterString = buildEmailActivityFilterString(fact, params.filterIndex);
            switch (time) {
                case '<=':
                    filterString += `&&${buildEmailTimeBeforeFilterString(params)}`;
                    break;
                case '>=':
                    filterString += `&&${buildEmailTimeSinceFilterString(params)}`;
                    break;
                case 'withinLast':
                    filterString += `&&${buildEmailTimeWithinLastFilterString(params)}`;
                    break;
                case '!withinLast':
                    filterString += `&&${buildEmailTimeNotWithinLastFilterString(params)}`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
        case 'notdelivered':
        case 'notopened':
        case 'notclicked':
            type = noEmailActivityTypeMap[fact] || '';
            filterString = buildNoEmailActivityFilterString(type, params.filterIndex);
            switch (time) {
                case '<=':
                    filterString += `||${buildNotEmailTimeBeforeFilterString({ ...params, type })}`;
                    break;
                case '>=':
                    filterString += `||${buildNotEmailTimeSinceFilterString({ ...params, type })}`;
                    break;
                case 'withinLast':
                    filterString += `||${buildNotEmailTimeWithinLastFilterString({ ...params, type })}`;
                    break;
                case '!withinLast':
                    filterString += `||${buildNotEmailTimeNotWithinLastFilterString({ ...params, type })}`;
                    break;
                // default 'ever'; nothing appended
            }
            break;
    }

    return { filter: filterString };
}
